import { fontSizes } from "~/utils/theme";

export type ArticleCardType = "featured" | "mobile" | "narrow" | "standard";

interface CalcSkeletonCardCount {
  width: string;
  noOfRows: number;
  windowInnerWidth?: number;
}

export const calcSkeletonCardCount = ({
  width,
  noOfRows,
  windowInnerWidth = window.innerWidth,
}: CalcSkeletonCardCount) => {
  const maxPixels = Math.min(80 * 16, windowInnerWidth);
  const actualWidth = (parseInt(width, 10) + 2) * 16;
  const calCount = Math.floor(maxPixels / actualWidth) * noOfRows;
  const count = calCount || 1;
  return count;
};

export type DimensionProps = {
  base: string;
  sm?: string;
};

type CardSizeProps = {
  [key in ArticleCardType]: {
    fontSize: string;
    height: DimensionProps;
    heroImg: {
      height: number;
      width: number;
    };
    topic: {
      height: string;
      offset: string;
      fontSize: string;
      width: string;
    };
    width: DimensionProps;
  };
};

export const articleCardStyleProps: CardSizeProps = {
  featured: {
    fontSize: fontSizes.md,
    height: { base: "30rem" },
    heroImg: {
      height: 384, // in pixels for img url
      width: 480, // in pixels for img url
    },
    topic: {
      height: "4.5rem",
      offset: "-2.25rem",
      fontSize: fontSizes.sm,
      width: "4.5rem",
    },
    width: { base: "100%", sm: "23rem" },
  },
  mobile: {
    fontSize: fontSizes.sm,
    height: { base: "90vw" },
    heroImg: {
      height: 150, // in pixels for img url
      width: 272, // in pixels for img url
    },
    topic: {
      height: "3.75rem",
      offset: "-1.875rem",
      fontSize: fontSizes.x1s,
      width: "3.75rem",
    },
    width: { base: "100%" },
  },
  narrow: {
    fontSize: fontSizes.x1s,
    height: { base: "13.5rem" },
    heroImg: {
      height: 102, // in pixels for img url
      width: 176, // in pixels for img url
    },
    topic: {
      height: "2.75rem",
      offset: "-1.375rem",
      fontSize: fontSizes.x2s,
      width: "2.75rem",
    },
    width: { base: "11rem" },
  },
  standard: {
    fontSize: fontSizes.sm,
    height: { base: "17.5rem" },
    heroImg: {
      height: 150, // in pixels for img url
      width: 272, // in pixels for img url
    },
    topic: {
      height: "3.75rem",
      offset: "-1.875rem",
      fontSize: fontSizes.x1s,
      width: "3.75rem",
    },
    width: { base: "17rem" },
  },
};
